import { useSelector, useDispatch } from 'react-redux';

import appSelectors from 'redux/app/appSelectors';

import { setTheme } from 'redux/app/appSlice';

import MoonIcon from 'images/header/moon.svg?react';
import SunIcon from 'images/header/sun.svg?react';

import s from './btnTheme.module.css';

function BtnTheme() {
  const dispatch = useDispatch();
  const theme = useSelector(appSelectors.theme);

  const toggleTheme = () => {
    const nextTheme = theme === 'dark' ? 'light' : 'dark';
    dispatch(setTheme(nextTheme));
  };

  return (
    <button
      type="button"
      onClick={toggleTheme}
      className={s.btn_theme}
      title="theme"
    >
      {theme === 'dark' ? <SunIcon /> : <MoonIcon />}
    </button>
  );
}

export default BtnTheme;
